<template>
    <div class="monthTopic">
        <h3>本月重点选题</h3>
        <div class="content">
            <ul>
                <li v-for="(item, index) in dataList" class="clearBoth">
                    <a class="clearBoth" @click="toDetail(item.group, item.title)">
                        <i>{{ pageSize * (currentPage - 1) + index + 1 }}</i>
                        <h4 :title="item.title">{{ item.title }}</h4>
                        <div class="clearBoth">
                            <span>{{ item.group }}</span>
                            <span>{{ item.userName }}</span>
                        </div>
                    </a>
                </li>
            </ul>
            <el-pagination
                    :page-size="pageSize"
                    :current-page="currentPage"
                    :pager-count="pagerCount"
                    @current-change="currentChange"
                    :hide-on-single-page="hide"
                    layout="prev, pager, next"
                    :total="total">
            </el-pagination>
        </div>
    </div>
</template>

<script>
    import {getNow} from '../../assets/js/common.js'
    export default {
        name: "monthTopic",
        data() {
            return {
                pageSize: 4,
                currentPage: 1,
                total: 0,
                pagerCount: 5,
                hide: true,
                allData: [],
                dataList:[],
                timer: null,
            }
        },
        mounted(){
            this.getDataList();
            this.timer =setInterval(() => {
                this.getDataList();
            }, 1000*60*15);
        },
        methods: {
            getDataList(){
                // this.axios.get('/bigscreen/benyueliebiao_list.json').then(res => {
                    // this.allData = res.data.data;
                    // this.dataList = this.allData.slice((this.currentPage - 1) * this.pageSize, this.currentPage*this.pageSize);
                    // this.total = res.data.data.length;
                // });
                let _that = this;
                let arr = [];
                this.axios.get('/screen/theme/getMonthDetail', {params: {dateTime: getNow('yyyymmdd')}}).then(res => {
                    for(let key in res.data){
                        res.data[""+key+""].map(item => {arr.push(item)});
                    }
                    _that.allData = arr;
                    _that.dataList = _that.allData.slice((_that.currentPage - 1) * _that.pageSize, _that.currentPage * _that.pageSize);
                    _that.total = _that.allData.length;
                })
            },
            currentChange(index){
                this.currentPage = index;
                this.dataList = this.allData.slice((this.currentPage - 1) * this.pageSize, this.currentPage*this.pageSize);
            },
            toDetail(group, title) {
                this.$router.push({path:'/detail', query: {type: 'getMonthDetail', group: group, title: title}});
            }
        },
        // 页面销毁前
        beforeDestroy(){
            clearInterval(this.timer);
        }
    }
</script>

<style scoped>
    .monthTopic{
        background: url("../../assets/images/monthTopicBG.png") center center no-repeat;
        background-size: 100% 100%;
        width: 760px;
        height: 754px;
        position: relative;
        box-sizing: border-box;
        padding: 80px 30px 62px 51px;
        margin-top: 80px;
    }
    .monthTopic h3{
        font-size: 42px;
        position: absolute;
        top: -35px;
        left: 50%;
        transform: translateX(-50%);
        color: #fff;
        font-weight: normal;
        font-family: hyk1gj;
    }
    .monthTopic .content{
        height: 100%;
        overflow-y: auto;
        -ms-overflow-style: none;
        scrollbar-width: none;
    }
    .monthTopic .content::-webkit-scrollbar{
        display: none;
    }

    .monthTopic ul{
        margin-right: 10px;
        margin-top: 4px;
    }
    ul li {
        padding: 26px 0;
    }
    ul li h4{
        font-size: 32px;
        line-height: 32px;
        margin-bottom: 26px;
        float: left;
        width: calc(100% - 104px);
        color: #fff;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        margin-left: 20px;
    }
    ul li i{
        float: left;
        width: 74px;
        height: 74px;
        display: flex;
        justify-content: center;
        align-items: center;
        color: #000;
        background: url("../../assets/images/todayTopicIndexBg.png") center center no-repeat;
        background-size: 100% 100%;
    }
    ul li a {
        display: block;
        width: 100%;
        height: 100%;
    }
    ul li a div{
        float: left;
        margin-left: 20px;
        width: calc(100% - 104px);
    }
    ul li span{
        font-size: 28px;
        color: #88b5fb;
        display: block;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        width: 50%;
        line-height: 28px;
        float: left;
    }
</style>
